<template>

  <v-container fluid>
    <!-- <v-layout row wrap v-for="meetup in meetups" :key="meetup.id" class="mb-2"> -->
    <v-layout row wrap >
 
    
      <v-flex  xs12 sm12 md12 lg12 x12 > 
          <!-- <a v-bind:href="'#' + award.type"> -->
              <div class="page-title pt-3">DIGEST <span class="title-bar">|</span> 2017</div>
          <!-- </a> -->
      </v-flex>
   
      
      <!-- <v-flex xs12 sm10 md8 offset-sm1 offset-md2> -->
      <v-flex xs12 sm12 md12 lg12 x12 >

      <v-card class="grid card-block" >
       
        <!-- <v-subheader>AWARD 2017 - {{id}}</v-subheader> -->
        <v-container fluid grid-list-sm>
         
          <v-layout row wrap>

           
            <!-- <v-flex xs12 sm12 md6 lg4 xl4 v-for="meetup in meetupsFiltersType"
            :key="meetup.id" 
            :meetupType = "meetup.type"
            v-if="meetup.type == id  &&  getYear( meetup.date) == '2017'" 
            class="image-inner"> -->
            <v-flex xs12 sm12 md4 lg2 xl2 v-for="meetup in meetups"
            :key="meetup.id" 
            v-if="meetup.category == id  &&  meetup.type == 'post'  &&getYear( meetup.date) == '2017'"  
            class="image-inner">

              <div class="image-border" > 
               <img class="image" 
                v-bind:src="meetup.imageUrl" 
                :alt="meetup.title" 
                 @click="onLoadMeetup(meetup.id)"
                  style="cursor: pointer;"
               >
               
                <!-- <p class="image-cap ">No.{{meetup.stageNo}} {{meetup.title}}</p>  -->
                <p class="image-cap "> {{meetup.title.slice(0,12)}}...</p> 
                <!-- <p class="image-link ">No.{{meetup.stageNo}} {{meetup.title}}</p>  -->
                <!-- <a v-bind:href="meetup.link" target="_blank"><p class="image-link ">Blog Page<v-icon color="grey darken-1">chevron_right</v-icon></p></a> -->

              </div>
              


            </v-flex>
          </v-layout>
        </v-container>
        <br>
       
      </v-card>
       
      </v-flex>
      </v-layout>
      
      <v-layout row wrap >
      <v-flex xs12 sm12 md6 lg4 xl4 style="text-align: left;">
         <v-btn  @click="goBack(meetupType)">
                Back
                  <span slot="loader" class="custom-loader">
                  <v-icon>cached</v-icon>
                  </span>
              </v-btn>
      </v-flex>
    </v-layout>
    
    
    
  </v-container>
</template>

<script>
export default {
  props: ['id'],
     data () {
      return {
       
        awards: [
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0208b1x1.jpg',
            id:1, 
            title:'BEST TITLE', 
            titleJp:'タイトル部門', 
            subTitle:'Select the best title image from all the stages', 
            subTitleJp:'２０１７年に投稿した１１ステージのタイトル画像から最も気に入っているデザインを選びました。', 
            type:'awStage'
            },
            {imageUrl: ' http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0259.jpg',
            id:2, 
            title:'BEST STAGE', 
            titleJp:'ベストステージ部門', 
            subTitle:'Select the best post image from all the stages', 
            subTitleJp:'各ステージの中から一番のお気に入りを選びました。', 
            type:'awPost'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/img2931.jpg',
            id:3, 
            title:'BEST DAYTIME', 
            titleJp:'デイタイム部門', 
            subTitle:'Select the best Daytime image from all the stages', 
            subTitleJp:'昼間のシーンからお気に入りを選びました。', 
            type:'awDaytime'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/09/b_road_panorama1b.jpg',
            id:4, 
            title:'BEST TWILIGHT', 
            titleJp:'トワイライト部門', 
            subTitle:'Select the best twilight image from all the stages', 
            subTitleJp:'夕暮れのシーンからお気に入りを選びました。', 
            type:'awTwilite'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img9665.jpg',
            id:5, 
            title:'BEST NIGHT', 
            titleJp:'ナイト部門', 
            subTitle:'Select the best night image from all the stages', 
            subTitleJp:'夜景の中からお気に入りを選びました。', 
            type:'awNight'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2050/04/vintagecar_title1.jpg',
            id:6, 
            title:'BEST VEHICLE', 
            titleJp:'ビークル部門', 
            subTitle:'Select the best vehicle image from all the stages', 
            subTitleJp:'車、船など乗り物の画像から一番のお気に入りを選びました。', 
            type:'awVehicle'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/08/img1875base.jpg',
            id:7, 
            title:'BEST COMPOSIT', 
            titleJp:'合成部門', 
            subTitle:'Select the best composit image from all the stages', 
            subTitleJp:'３Dモデルの画像合成、アニメーション画像から一番のお気に入りを選びました。', 
            type:'awComposit'
            },
            {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img0749a1x1.jpg',
            id:8, 
            title:'BEST HDR', 
            titleJp:'ＨＤＲ部門', 
            subTitle:'Select the best HDR image from all the stages', 
            subTitleJp:'すべてのＨＤＲ画像から一番のお気に入りを選びました。', 
            type:'awHdr'
            }
        ]
        
        
      }
    },
  computed: {
      meetups () {
        return this.$store.getters.featuredMeetups
      },
      meetupsFiltersType () {
        // console.log('meetupsFiltersType')
        return this.$store.getters.featuredMeetupsFiltersType(this.id)
      },
      loading () {
        return this.$store.getters.loading
      }
  },
  

  methods: {
    onLoadMeetup (id) {
      this.$router.push('/post/' + id)
    },
    getYear( value) {
       const date = new Date(value)
     return  date.getFullYear().toString()
    },
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

*{
    box-sizing: border-box;
  }
main{
    display:block;
}
.best-title-inner h4 {
     border-bottom: solid 1px red;
      padding: 0  0 0 .5rem;
}
.best-description-inner {
    padding: 0 4rem;
}
.best-description-inner h6{
     line-height: 2.4rem;
     letter-spacing: .2rem;
    
}
.page-title {
    /* font-size: 112px; */
    font-size: 2em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
    color:white;
    padding: 0 2rem 0 2rem;
    text-transform: uppercase
}
.title-bar{
  color:red;
   font-weight: 100;
   font-size: 1.6em;
  vertical-align: -5px;

 
}
.card-block{
  background-color: black !important;
  /* border: solid 1px whitesmoke; */
  opacity: .8;
}
.image-inner{
   /* width:320px;
   height:320px; */
   padding: 2rem;
  margin: 1rem 0rem;
  display: flex;
  justify-content: center; 
  align-items: center;
  /* border:1px solid red; */
  
  
  
}
.image-border{
  width:100%;
  height:100%;
  margin: 20px 20px;
  border:1px solid gray;
  display: flex;
  justify-content: center; 
  align-items: center;
  position: relative;
   
  }

  .image{
    width:auto;
    height:auto;
    max-width:100%;
    max-height:100%;
    padding: 2rem ;
  }
  .image-cap{
    position: absolute;
    top:0;
    left: 0;
    width:100%;
    padding:.2rem;
    color: gray;
  }
  .image-link{
    position: absolute;
    bottom:0;
    right: 0;
    width:100%;
    margin: 0 .4rem .2rem 0;
    color: gray;
    text-align: right;

  }
  
  .bg-image{
     background-size: cover;
  background-position: center center;
  }
.page-title {
    font-size: 1em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
    color:white;
    padding: 0 2rem 0 2rem;
    text-transform: uppercase
}
  .title-bar{
    color:red;
    font-weight: 400;
    font-size: 1.6em;
    vertical-align: -1px;
  }
  .page-category{
    font-size: 1em;
    font-weight: 300;

  }

/* h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
} */

/* xs */
@media only screen and (max-width: 600px){
   .page-title {
    font-size: 1em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
    color:white;
    padding: 0 2rem 0 2rem;
    text-transform: uppercase
}
  .title-bar{
    color:red;
    font-weight: 400;
    font-size: 1.6em;
    vertical-align: -1px;
  }
  .page-category{
    font-size: 1em;
    font-weight: 300;

  }
   
}
/* sm */
@media only screen and (min-width: 599px) and (max-width: 959px){
   .page-title {
    font-size: 2em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
    color:white;
    padding: 0 2rem 0 2rem;
    text-transform: uppercase
}
.title-bar{
  color:red;
   font-weight: 100;
   font-size: 1.6em;
  vertical-align: -5px;
}
.page-category{
  font-size: 2em;
  font-weight: 300;

} 
  
  
}
/* ms */
@media only screen and (min-width: 960px) and (max-width: 1264px){
   .page-title {
    font-size: 2em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
    color:white;
    padding: 0 2rem 0 2rem;
    text-transform: uppercase
}
.title-bar{
  color:red;
   font-weight: 100;
   font-size: 1.6em;
  vertical-align: -5px;
}
.page-category{
  font-size: 2em;
  font-weight: 300;

}  
}
/* lg */
@media only screen and (min-width: 1265px) and (max-width: 1904px){
    .page-title {
    font-size: 2em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
    color:white;
    padding: 0 2rem 0 2rem;
    text-transform: uppercase
}
.title-bar{
  color:red;
   font-weight: 100;
   font-size: 1.6em;
  vertical-align: -5px;
}
.page-category{
  font-size: 2em;
  font-weight: 300;

} 
  
}
/* xl */
@media only screen and (min-width: 1905px) {
   .page-title {
    font-size: 2em;
    font-weight: 300;
    line-height: 1;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
    color:white;
    padding: 0 2rem 0 2rem;
    text-transform: uppercase
}
.title-bar{
  color:red;
   font-weight: 100;
   font-size: 1.6em;
  vertical-align: -5px;
}
.page-category{
  font-size: 2em;
  font-weight: 300;

} 
  
}
</style>



// WEBPACK FOOTER //
// src/components/digest/stageThumnail.vue